export const MenuActionType = {
  ACTION_SET_ROUTES: 'ACTION_SET_ROUTES'
}
